import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "..";
import {
  manageCommunicationStore,
  setManageReportsFlow,
  setManageCommunicationToastInfo,
  getReportsDetailsAction,
} from "../../contexts";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  MANAGE_REPORTS_ROUTES,
  ROUTES,
  manageReportsFormNames,
  apiErrors,
  getPathWithParam,
  ALL_MANAGE_REPORTS_ROUTES,
} from "../../utils";
import Cancel from "../../styles/cancel.png";
import { useFormikContext } from "formik";
import RouteLeavingGuard from "../RouteLeavingGuard";

const ManageCommunicationLayout = ({
  showLayout,
  pageName,
  children,
  buttons = [],
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  overflow = "overflow-auto",
  blockNavigation,
  buttonAlign = false,
}) => {
  const [showError, setShowError] = useState(false);
  const [className, setClassName] = useState(overflow);
  const { state, dispatch } = useContext(manageCommunicationStore);
  //   const reportName = get(
  //     state,
  //     `${manageReportsFormNames.ELIGIBILITY_FILTER}.reportName`
  //   );
  const { reportId, flow } = useRouterParams();
  const { showToast, toastMessage } = state;
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };

  const apiError = get(state, "api.error", {});
  const apiData = get(state, "api.data", {});

  //   const menuDetails = find(ALL_MANAGE_REPORTS_ROUTES, (item) => {
  //     if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
  //       return true;
  //     }
  //     return false;
  //   });

  //   useDeepEffect(() => {
  //     if (isEmpty(apiData) && reportId) {
  //       dispatch(getReportsDetailsAction(reportId, dispatch, state));
  //       dispatch(setManageReportsFlow({ flow, reportId }));
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [reportId]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Communications",
      link: ROUTES.MANAGE_COMMUNICATION,
    },
  ];

  //   if (reportName) {
  //     breadCrumOptions.push({
  //       label: reportName,
  //       link: getPathWithParam({
  //         path: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
  //         pathParam: [flow, reportId],
  //       }),
  //     });
  //   }

  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  }
  //   const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  //   if (!isEmpty(customBreadCrumbs)) {
  //     breadCrumOptions.push(...customBreadCrumbs);
  //   } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
  //     breadCrumOptions.push(
  //       ...breadCrumbsFromMenuDetails.map((item) => ({
  //         ...item,
  //         link: getPathWithParam({
  //           path: item.link,
  //           pathParam: [flow, reportId],
  //         }),
  //       }))
  //     );
  //   }

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];
  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };
  useDeepEffect(() => {
    setClassName(`layout-content h-100 ${overflow}`);
  }, [overflow]);
  //const className=
  return (
    <div className="d-flex flex-column manage-report h-100">
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div>
            {/* <Breadcrumb>
              {breadCrumOptions.slice(-4).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  <Link to={item.link}>{item.label}</Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb> */}
            <div className="core-heading-4">{pageName}</div>
            <h5>{layoutHeader || ""}</h5>
          </div>
          <div
            className={
              showLayout
                ? "canc-but"
                : `ml-auto ${buttonAlign ? "button-align" : ""}`
            }
          >
            <InnerLayoutButtons
              menu="communication"
              buttonsList={buttons}
              flow={pageFlow}
            />
          </div>
          {showError && (
            <div
              className={`error-banner justify-content-between d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <Image src={Cancel} width="30px" />
              </div>
              <div>
                <div className="error-heading">{errorData.heading}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#000"
                  style={{ fontSize: "14px" }}
                  onClick={() => setShowError(false)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={className}>{children}</div>
      <Toast
        onClose={() =>
          dispatch(
            setManageCommunicationToastInfo({
              showToast: false,
              toastMessage: "",
            })
          )
        }
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-2">
            {showToast ? (
              <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="lg" />
            ) : (
              ""
            )}
          </div>
          <div>{toastMessage}</div>
          <div className="ml-2">
            {showToast ? (
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000000"
                size="md"
                onClick={() =>
                  dispatch(
                    setManageCommunicationToastInfo({
                      showToast: false,
                      toastMessage: "",
                    })
                  )
                }
              />
            ) : (
              ""
            )}
          </div>
        </Toast.Body>
      </Toast>
      <RouteLeavingGuard
        when={!isSubmitting && dirty}
        navigate={(path) => history.push(path)}
        onRefresh={onRefresh}
        blockNavigation={blockNavigation}
      />
    </div>
  );
};

export default withRouter(ManageCommunicationLayout);
